const prefix = ''

export const reportUrls = {
  'reportTemplate.list': `${prefix}/report-templates`,
  'reportTemplate.add': `${prefix}/report-templates/add`,
  'reportTemplate.view': (id = ':templateId') =>
    `${prefix}/report-templates/${id}`,
  'reportTemplate.edit': (id = ':templateId') =>
    `${prefix}/report-templates/${id}/edit`,
  'report.list': `${prefix}/reports`,
  'report.add': `${prefix}/reports/add`,
  'report.view': (id = ':reportId') => `${prefix}/reports/${id}`,
  'report.edit': (id = ':reportId') => `${prefix}/reports/${id}/edit`,
}
